import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { fetchPlaceOfTable, fetchTables } from "../actions/restaurantActions";
import RoomLayoutEditor from "../place_design/RoomLayoutEditor";

const FullWidthPage = styled.main`
  width: 100%;
  max-width: none;
  padding: 0;

  @media (max-width: 620px) {
    padding: 0;
  }
`;

export const PlaceDesignScreen = () => {
  const dispatch = useDispatch();
  const { restaurants } = useSelector((state) => state.restaurantDetails);

  useEffect(() => {
    if (!restaurants?.id) return;
    dispatch(fetchTables(restaurants.id));
    dispatch(fetchPlaceOfTable(restaurants.id));
  }, [dispatch, restaurants?.id]);

  return (
    <FullWidthPage>
      <RoomLayoutEditor />
    </FullWidthPage>
  );
};

export default PlaceDesignScreen;
